import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class LocusRobotics_ds_jobs_detail_gridService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { fullTextSearch?: string, orderId?: string, $top?: number, $skip?: number }): Promise<{ result?: { jobTaskId?: string, orderId?: string, orderLineNumber?: string, taskLocation?: string, taskZone?: string, taskQty?: number, itemNo?: string, itemDesc?: string, custom1?: string, countEligible?: boolean, serialValidation?: boolean, jobId?: string }[], totalCount?: number }> {
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { fullTextSearch?: string, orderId?: string, $keys: string[] }): Promise<{ result?: { jobTaskId?: string, orderId?: string, orderLineNumber?: string, taskLocation?: string, taskZone?: string, taskQty?: number, itemNo?: string, itemDesc?: string, custom1?: string, countEligible?: boolean, serialValidation?: boolean, jobId?: string }[] }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
}
